import { ChannelType, type Call, type Channel, type ReadState, type Relationship, type UserGuildSettings } from '@/types/api'
import { compareIds } from './messageMerge'
import { ownMuted } from './muting'

interface Input {
  channels: Record<string, Channel>
  readStates: Record<string, ReadState>
  calls: Record<string, Call>
  relationships: Record<string, Relationship>
  settings: UserGuildSettings | undefined
  selfId: string | null
  activeCallId: string | null
}

/** Личные беседы над серверами: свой звонок, входящие звонки, затем новые сообщения. */
export function dmRailEntries({ channels, readStates, calls, relationships, settings, selfId, activeCallId }: Input) {
  if (!selfId) return []
  return Object.values(channels).flatMap((channel) => {
    if (channel.type !== ChannelType.DM && channel.type !== ChannelType.GroupDM) return []
    const inCall = channel.id === activeCallId
    const blocked = channel.type === ChannelType.DM && channel.recipients?.some((u) => relationships[u.id]?.type === 2)
    const quiet = ownMuted(settings, channel.id) || blocked
    const unread = quiet ? 0 : Math.max(0, readStates[channel.id]?.mention_count ?? 0)
    const ringing = !quiet && Boolean(calls[channel.id]?.ringing.includes(selfId)) && !inCall
    if (!inCall && !ringing && !unread) return []
    return [{ channel, unread, inCall, ringing }]
  }).sort((a, b) => {
    const priority = (entry: { inCall: boolean; ringing: boolean }) => entry.inCall ? 2 : entry.ringing ? 1 : 0
    return priority(b) - priority(a)
      || -compareIds(a.channel.last_message_id ?? calls[a.channel.id]?.message_id ?? a.channel.id, b.channel.last_message_id ?? calls[b.channel.id]?.message_id ?? b.channel.id)
      || -compareIds(a.channel.id, b.channel.id)
  })
}
